import React from "react";

/**
 * The Precision app's Intake icon (a pie split into two quarter arcs), ported
 * from `PrecisionReactNative/.../daily/icons/IntakeIconSvg`. Used on the
 * nutrition plan's Intake buttons.
 */
const IntakeIcon = ({ size = 14, fill }: { size?: number; fill: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 1.5C2.325 1.5 0 3.825 0 6.75C0 9.675 2.325 12 5.25 12C8.175 12 10.5 9.675 10.5 6.75H5.25V1.5Z"
      fill={fill}
    />
    <path d="M6.75 0V5.25H12C12 2.325 9.675 0 6.75 0Z" fill={fill} />
  </svg>
);

export default IntakeIcon;
